import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SafePipe } from './pipes/sanitizer.pipe';
import { OnlyNumber } from './directives/only-number.directive';
import { TwoDigitDecimaNumberDirective } from './directives/two-decimal-number.directive';
import { TrimAddressPipe } from './pipes/trim-address.pipe';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { SignificantDecimalPipe } from './pipes/significant-decimal.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';

@NgModule({
  declarations: [SafePipe, TrimAddressPipe, NumberFormatPipe, SignificantDecimalPipe, TimeAgoPipe, OnlyNumber, TwoDigitDecimaNumberDirective, NotificationsComponent],
  imports: [CommonModule],
  exports: [SafePipe, TrimAddressPipe, NumberFormatPipe, SignificantDecimalPipe, TimeAgoPipe, OnlyNumber, TwoDigitDecimaNumberDirective, NotificationsComponent],
})
export class SharedModule {}
